<template>
    <div class="form">
        <v-form
            ref="form"
            v-model="valid"
            lazy-validation
        >
            <v-layout>
                <v-flex xs12>
                    <v-layout row>
                        <v-flex md12>
                            <div class="content-wrapper">
                                <div class="info-block">
                                    Fill all information below
                                </div>
                            </div>
                        </v-flex>
                    </v-layout>
                    <v-layout row v-if="errors !== null">
                        <v-flex md12>
                            <div class="content-wrapper">
                                <div class="error-block">
                                    <div class="title">Errors</div>
                                    <p v-html="errors"></p>
                                </div>
                            </div>
                        </v-flex>
                    </v-layout>
                    <v-layout row justify-space-around>
                        <v-flex md6>
                            <div class="content-wrapper">
                                <v-layout row>
                                    <v-flex xs4>
                                        <div class="label text-xs-right">
                                            <span class="text-xs-right">Vehicle fleet <span class="required">*</span></span>
                                        </div>
                                    </v-flex>
                                    <v-flex xs8>
                                        <fleet-autocomplete v-model="form.fleet" :rules="rules.fleet"></fleet-autocomplete>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs4>
                                        <div class="label text-xs-right">
                                            <span class="text-xs-right">Registration <span class="required">*</span></span>
                                        </div>
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-text-field
                                            label="Insert registration number"
                                            v-model="form.registration"
                                            :rules="rules.registration"
                                            required
                                            outline
                                            single-line
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs4>
                                        <div class="label text-xs-right">
                                            <span class="text-xs-right">Manufacturer <span class="required">*</span></span>
                                        </div>
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-text-field
                                            label="Insert manufacturer name"
                                            v-model="form.manufacturer"
                                            :rules="rules.manufacturer"
                                            required
                                            outline
                                            single-line
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs4>
                                        <div class="label text-xs-right">
                                            <span class="text-xs-right">Model <span class="required">*</span></span>
                                        </div>
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-text-field
                                            label="Insert car model"
                                            v-model="form.model"
                                            :rules="rules.model"
                                            required
                                            outline
                                            single-line
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs4>
                                        <div class="label text-xs-right">
                                            <span class="text-xs-right">Fuel <span class="required">*</span></span>
                                        </div>
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-select
                                            v-model="form.fuelType"
                                            :items="fuelTypes"
                                            label="Choose type of fuel"
                                            :rules="rules.fuelType"
                                            item-text="key"
                                            item-value="id"
                                            required
                                            outline
                                            single-line
                                        ></v-select>
                                    </v-flex>
                                </v-layout>
                            </div>
                        </v-flex>
                        <v-flex md6>
                            <div class="content-wrapper">
                                <v-layout row>
                                    <v-flex xs4>
                                        <div class="label text-xs-right">
                                            <span class="text-xs-right">Year of manufacture <span class="required">*</span></span>
                                        </div>
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-text-field
                                            label="Insert year of manufacture"
                                            v-model.number="form.yearOfManufacture"
                                            :rules="rules.yearOfManufacture"
                                            mask="####"
                                            required
                                            outline
                                            single-line
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs4>
                                        <div class="label text-xs-right">
                                            <span class="text-xs-right">Mileage <span class="required">*</span></span>
                                        </div>
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-text-field
                                            label="Insert mileage"
                                            placeholder="Insert mileage"
                                            v-model.number="form.mileage"
                                            :rules="rules.mileage"
                                            :suffix="mileageText"
                                            required
                                            outline
                                            single-line
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs4>
                                        <div class="label text-xs-right">
                                            <span class="text-xs-right">Engine size <span class="required">*</span></span>
                                        </div>
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-text-field
                                            label="Insert engine size"
                                            v-model.number="form.engineSize"
                                            :rules="rules.engineSize"
                                            min="0"
                                            step="0.1"
                                            type="number"
                                            suffix="kW"
                                            required
                                            outline
                                            single-line
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs4>
                                        <div class="label text-xs-right">
                                            <span class="text-xs-right">Vehicle type <span class="required">*</span></span>
                                        </div>
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-select
                                            v-model.number="form.vehicleType"
                                            :items="vehicleTypes"
                                            label="Choose a vehicle type"
                                            :rules="rules.vehicleType"
                                            item-text="name"
                                            item-value="id"
                                            required
                                            outline
                                            single-line
                                        ></v-select>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs4>
                                        <div class="label text-xs-right">
                                            <span class="text-xs-right">Chassis Number</span>
                                        </div>
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-text-field
                                            label="Chassis number"
                                            placeholder="Chassis number"
                                            v-model="form.chassisNumber"
                                            :rules="rules.chassisNumber"
                                            outline
                                            single-line
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
            <v-layout row class="buttons">
                <v-flex xs6>
                    <sp-button @click.native="goBack" text="Go Back" small-icon icon="go-back" sp-class="disabled"></sp-button>
                </v-flex>
                <v-flex xs6 class="right text-xs-right">
                    <div class="content-wrapper">
                        <sp-button @click.native="validate" text="Save" icon="download"></sp-button>
                    </div>
                </v-flex>
            </v-layout>
        </v-form>
    </div>
</template>
\
<script>
import SpButton from '@/components/forms/Button'
import router from '@/router/routes'
import { mapGetters } from 'vuex'
import FleetAutocomplete from '@/views/Fleets/components/FleetAutocomplete.vue'

export default {
    name: 'VehicleForm',
    components: {
        FleetAutocomplete,
        SpButton
    },
    props: {
        handler: {
            type: Function,
            required: true
        },
        form: {
            type: Object,
            required: true
        },
        fleetUuid: {
            type: String,
            required: false,
            default: null
        },
        isPopup: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data () {
        return {
            valid: false,
            errors: null,
            rules: {
                fleet: [
                    v => !!v || 'Fleet is required'
                ],
                registration: [
                    v => (v.length && 1 <= v.trim().length && 50 >= v.trim().length) || 'Registration number must be at least 1 and less than 50 characters',
                    v => (v === v.trim()) || 'Registration number cannot have leading or trailing spaces'
                ],
                manufacturer: [
                    v => (v.length && 1 <= v.trim().length && 50 >= v.trim().length) || 'Manufacturer must be at least 1 and less than 50 characters',
                    v => (v === v.trim()) || 'Manufacturer cannot have leading or trailing spaces'
                ],
                model: [
                    v => (v.length && 1 <= v.trim().length && 50 >= v.trim().length) || 'Model must be at least 1 and less than 50 characters',
                    v => (v === v.trim()) || 'Model cannot have leading or trailing spaces'
                ],
                chassisNumber: [
                    v => (100 >= (v || '').trim().length) || 'Chassis number must be less than 100 characters',
                    v => (v === (v || '').trim() || null === v) || 'Chassis number cannot have leading or trailing spaces'
                ],
                fuelType: [
                    v => null !== v || 'Fuel type is required'
                ],
                yearOfManufacture: [
                    v => (v && 1950 <= v && new Date().getFullYear() >= v) || `Year must be between 1950 and ${new Date().getFullYear()}.`
                ],
                mileage: [
                    v => !/d+(\.\d+)?/g.exec(v) || 'Mileage must be a number',
                    v => 0 < v || 'Mileage must be grater than 0',
                    v => 100000000 > v || 'Mileage must be less than 100,000,000'
                ],
                engineSize: [
                    v => !/d+(\.\d+)?/g.exec(v) || 'Engine size must be a number',
                    v => (0 < v && 100 > v) || 'Engine size must be between 0 and 100'
                ],
                vehicleType: [
                    v => null !== v || 'Vehicle type is required'
                ]
            }
        }
    },
    computed: {
        ...mapGetters('dictionaryModule', {
            getVehicleTypes: 'getVehicleTypes',
            fuelTypes: 'getFuelTypes'
        }),
        ...mapGetters('authModule', [
            'getSpeedUnit'
        ]),
        vehicleTypes () {
            const availableCategories = [1, 2, 3, 4]
            return this.getVehicleTypes.filter(vehicleType => availableCategories.includes(vehicleType.id))
        },
        mileageText () {
            return 0 === this.getSpeedUnit ? 'km' : 'mi'
        }
    },
    methods: {
        async validate () {
            this.valid = this.$refs.form.validate()
            if (!this.valid) {
                return false
            }

            this.form.fleetId = null !== this.fleetUuid ? this.fleetUuid : this.form.fleet.id
            try {
                this.errors = null
                await this.handler(this.form)
            } catch (e) {
                this.errors = e.message
            }
        },
        goBack () {
            if (this.isPopup) {
                this.$emit('go-back', true)
            } else {
                router.back()
            }
        }
    }
}
</script>

<style scoped lang="scss">
.color-picker-switch {
    cursor: pointer;
    height: 30px;
    width: 30px;
    border: 1px solid #000000;
    border-radius: 4px;
    transition: border-radius 0.2s ease;

    &--open {
        border-radius: 50%;
    }
}
</style>
